<div class="flex flex-col h-[70vh] bg-white relative">
  
  <!-- Chat Area -->
  <div #chatContainer class="flex-1 overflow-y-auto px-4 pb-28 pt-6 space-y-8">
    
    <!-- Welcome message if empty -->
    <div *ngIf="messageResponsePairs.length === 0" class="flex flex-col items-center justify-center h-full text-gray-500 opacity-60">
      <img src="../../../assets/icons/copilot-bot.png" class="w-16 h-16 mb-4 grayscale" alt="Bot" />
      <p>Ask anything about the induction training.</p>
    </div>

    <!-- Message Pairs -->
    <div *ngFor="let pair of messageResponsePairs" class="flex flex-col space-y-4">
      
      <!-- User Message -->
      <div class="self-end max-w-[80%] md:max-w-[70%]">
        <div class="bg-[#1D4586] text-white p-4 rounded-2xl rounded-tr-sm text-sm shadow-sm leading-relaxed">
          {{ pair.message }}
        </div>
      </div>

      <!-- Bot Loading -->
      <div *ngIf="pair.loading" class="self-start max-w-[80%] md:max-w-[70%]">
        <div class="bg-gray-50 border border-gray-100 text-gray-800 p-4 rounded-2xl rounded-tl-sm text-sm shadow-sm flex items-center space-x-2">
          <div class="w-2 h-2 rounded-full animate-pulse bg-gray-400"></div>
          <div class="w-2 h-2 rounded-full animate-pulse bg-gray-400 animation-delay-200"></div>
          <div class="w-2 h-2 rounded-full animate-pulse bg-gray-400 animation-delay-400"></div>
        </div>
      </div>

      <!-- Bot Response -->
      <div *ngIf="pair.response" class="self-start max-w-[80%] md:max-w-[70%]">
        <div class="bg-gray-50 border border-gray-100 text-gray-800 p-4 rounded-2xl rounded-tl-sm text-[14px] leading-relaxed shadow-sm" [innerHTML]="pair.response">
        </div>
      </div>

    </div>
  </div>

  <!-- Bottom Input Area (Sticky) -->
  <div class="absolute bottom-0 left-0 w-full bg-white bg-opacity-95 backdrop-blur pt-2 pb-6 px-4 flex flex-col">

    <!-- Voice Recording Status -->
    <div *ngIf="isListening || isProcessing || voiceError" class="flex justify-end px-2 pb-1.5">
      <span *ngIf="isListening" class="text-xs text-gray-500 italic">Listening... Speak clearly.</span>
      <span *ngIf="isProcessing" class="text-xs text-gray-500 italic">Processing your speech...</span>
      <span *ngIf="voiceError" class="text-xs text-red-500 italic">{{ voiceError }}</span>
    </div>

    <!-- Input Box -->
    <div class="relative flex items-center bg-[#E9F0E6] rounded-xl border border-[#cbe0c5] shadow-inner px-4 py-2 focus-within:ring-1 focus-within:ring-[#1D4586] transition-all">
      
      <textarea id="chatInput"
                [(ngModel)]="inputText" 
                (input)="adjustTextareaHeight($event)"
                (keydown)="onKeyDown($event)"
                placeholder="Ask anything about the induction training..."
                class="flex-grow bg-transparent border-none outline-none resize-none text-sm text-gray-800 placeholder-gray-500 overflow-y-auto leading-relaxed py-2"
                style="height: 40px; min-height: 40px;"></textarea>

      <!-- Action Buttons -->
      <div class="flex items-center ml-2 space-x-2 h-full">
        <!-- Mic Icon -->
        <button (click)="toggleVoiceRecognition()" class="p-2 text-gray-500 hover:text-[#1D4586] transition-colors focus:outline-none flex justify-center items-center h-8 w-8">
          <svg *ngIf="!isListening" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-5 h-5">
            <rect x="9" y="3" width="6" height="12" rx="3"></rect>
            <path d="M5 11a7 7 0 0 0 14 0"></path>
            <path d="M12 18v3"></path>
          </svg>
          <!-- Pulsing dot when listening -->
          <div *ngIf="isListening" class="w-4 h-4 rounded-full bg-red-500 animate-pulse"></div>
        </button>

        <!-- Send Button -->
        <button (click)="sendMessage()" 
                [disabled]="!inputText.trim() || isResponseLoading"
                class="w-8 h-8 rounded-full bg-white flex items-center justify-center text-[#1D4586] shadow-sm disabled:opacity-50 hover:bg-gray-50 transition-colors focus:outline-none border border-gray-200">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="w-4 h-4 ml-0.5">
            <path d="M5 12h14"></path>
            <path d="M13 6l6 6-6 6"></path>
          </svg>
        </button>
      </div>
    </div>

  </div>

</div>